import { render } from "./registerClient.vue?vue&type=template&id=4d85b46a&scoped=true"
import script from "./registerClient.vue?vue&type=script&lang=js"
export * from "./registerClient.vue?vue&type=script&lang=js"

import "./registerClient.vue?vue&type=style&index=0&id=4d85b46a&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/fundraise/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d85b46a"]])

export default __exports__